<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminRefundGroupOrder.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="conditions.returnId" :placeholder="$t('adminRefundGroupOrder.returnIdPlaceholder')"
                clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="conditions.orderId" :placeholder="$t('adminRefundGroupOrder.orderIdPlaceholder')"
                clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="conditions.returnType"
                :placeholder="$t('adminRefundGroupOrder.returnTypePlaceholder')" style="width:100%" clearable>
                <el-option :label="$t('adminRefundGroupOrder.all')" value=""></el-option>
                <el-option :label="$t('adminRefundGroupOrder.selfRefund')" value="1001"></el-option>
                <el-option :label="$t('adminRefundGroupOrder.groupFailRefund')" value="2002"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryAdminRefundGroupOrder" icon="el-icon-search">
                {{ $t('adminRefundGroupOrder.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminRefundGroupOrder.groupRefundOrder') }}</span>
          </div>
          <el-table :data="orders" border style="width: 100%" v-loading="loading">
            <el-table-column prop="returnId" :label="$t('adminRefundGroupOrder.returnId')"
              align="center"></el-table-column>
            <el-table-column prop="orderId" :label="$t('adminRefundGroupOrder.order')" align="center"></el-table-column>
            <el-table-column prop="prodName" :label="$t('adminRefundGroupOrder.product')"
              align="center"></el-table-column>
            <el-table-column prop="buyerName" :label="$t('adminRefundGroupOrder.buyer')"
              align="center"></el-table-column>
            <el-table-column prop="buyerCount" :label="$t('adminRefundGroupOrder.buyCount')"
              align="center"></el-table-column>
            <el-table-column prop="groupPrice" :label="$t('adminRefundGroupOrder.groupPrice')"
              align="center"></el-table-column>
            <el-table-column prop="returnMoney" :label="$t('adminRefundGroupOrder.refundAmount')"
              align="center"></el-table-column>
            <el-table-column prop="returnType" :label="$t('adminRefundGroupOrder.refundType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.returnType === '1001' ? $t('adminRefundGroupOrder.selfRefund') :
                  $t('adminRefundGroupOrder.groupFailRefund') }}
              </template>
            </el-table-column>
            <el-table-column prop="reason" :label="$t('adminRefundGroupOrder.refundReason')"
              align="center"></el-table-column>
            <el-table-column prop="state" :label="$t('adminRefundGroupOrder.status')" align="center"></el-table-column>
            <el-table-column prop="stateMsg" :label="$t('adminRefundGroupOrder.auditDesc')"
              align="center"></el-table-column>
          </el-table>

          <el-pagination class="margin-top-20" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminRefundGroupOrder } from '@/api/group/refundGroupOrderApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  components: {
    AdminShop
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orders: [],
      conditions: {
        returnId: '',
        orderId: '',
        returnType: '',
        shopId: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleShopChange(shop) {
      this.conditions.shopId = shop.shopId
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    queryAdminRefundGroupOrder() {
      this.currentPage = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize
        }
        const res = await queryAdminRefundGroupOrder(params)
        this.orders = res.data
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.margin-top-20 {
  margin-top: 20px;
}
</style>